import { ChangeDetectorRef, Component, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-form-header',
  templateUrl: './form-header.component.html',
  styleUrls: ['./form-header.component.scss']
})
export class FormHeaderComponent {

  @Input() title: string; 
  @Input() icon: string;
  @Input() backUrl: string;
  
  constructor(
    private _router: Router
  ) {
  }

  goBack(): void {
    this._router.navigate([this.backUrl]);
  }
}
